"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/fileImg/index.vue"));
var _logo = require("@/api/logo/logo");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      provinceList: [],
      logoInfo: {
        id: "",
        adminLogo: "",
        webLogo: "",
        footer: "",
        loginLogo: "",
        title: "",
        provinceId: this.$route.query.id,
        expertAuthentication: "",
        newsBanner: '',
        resourceBanner: '',
        onlieCourseBanner: '',
        videoCouresBanner: '',
        competitionBanner: ''
      },
      imageUrl: "",
      propImg1: "",
      propImg2: "",
      propImg3: "",
      propImg4: "",
      propImg5: "",
      propImg6: "",
      propImg7: "",
      propImg8: ""
    };
  },
  methods: {
    successUpLoad: function successUpLoad(e) {
      this.logoInfo.webLogo = e.ossOriUrl;
    },
    successUpLoad2: function successUpLoad2(e) {
      this.logoInfo.loginLogo = e.ossOriUrl;
    },
    successUpLoad3: function successUpLoad3(e) {
      this.logoInfo.adminLogo = e.ossOriUrl;
    },
    successUpLoad4: function successUpLoad4(e) {
      this.logoInfo.newsBanner = e.ossOriUrl;
    },
    successUpLoad5: function successUpLoad5(e) {
      this.logoInfo.onlieCourseBanner = e.ossOriUrl;
    },
    successUpLoad6: function successUpLoad6(e) {
      this.logoInfo.videoCouresBanner = e.ossOriUrl;
    },
    successUpLoad7: function successUpLoad7(e) {
      this.logoInfo.competitionBanner = e.ossOriUrl;
    },
    successUpLoad8: function successUpLoad8(e) {
      this.logoInfo.resourceBanner = e.ossOriUrl;
    },
    submit: function submit() {
      var _this = this;
      this.logoInfo.provinceId = this.$route.query.id;
      (0, _logo.editProvLogo)(this.logoInfo).then(function (res) {
        if (res.code === 2000) {
          _this.$router.push("/webSet/logoSet");
        }
      });
    },
    // 通过省份ID获取省份logo
    getLogo: function getLogo() {
      var _this2 = this;
      (0, _logo.logoByProvId)({
        id: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        if (res.data) {
          _this2.logoInfo = data;
          _this2.propImg1 = data.webLogo;
          _this2.propImg2 = data.loginLogo;
          _this2.propImg3 = data.adminLogo;
          _this2.propImg4 = data.newsBanner;
          _this2.propImg5 = data.onlieCourseBanner;
          _this2.propImg6 = data.videoCouresBanner;
          _this2.propImg7 = data.competitionBanner;
          _this2.propImg8 = data.resourceBanner;
        } else {
          _this2.$message.error("请先新增省份logo，再进行编辑。");
        }
      });
    },
    // 返回
    isBack: function isBack() {
      this.$router.push("/webSet/logoSet");
    }
  },
  created: function created() {
    this.getLogo();
  },
  components: {
    FileImg: _index.default
  }
};